/**
 * Central config — reads from VITE_PUBLIC_* env vars with sensible fallbacks.
 * These are BUILD-TIME defaults. To change values without rebuilding:
 *   - Popup: drop a popup-config.json in your popups folder on the server
 *   - Other values: edit .env, then rebuild (npm run build)
 */

export const config = {
  gallery: {
    listUrl: import.meta.env.VITE_PUBLIC_GALLERY_LIST_URL || '',
    url: import.meta.env.VITE_PUBLIC_GALLERY_URL || 'https://ashoktelecom.com/images/',
  },
  logos: {
    listUrl: import.meta.env.VITE_PUBLIC_LOGOS_LIST_URL || '',
    url: import.meta.env.VITE_PUBLIC_LOGOS_URL || 'https://ashoktelecom.com/logos/',
  },
  popup: {
    listUrl: import.meta.env.VITE_PUBLIC_POPUP_LIST_URL || '',
    url: import.meta.env.VITE_PUBLIC_POPUP_URL || 'https://ashoktelecom.com/popups/',
    delayMs: Number(import.meta.env.VITE_PUBLIC_POPUP_DELAY_MS) || 1500,
    maxShown: 2,
  },
  social: {
    facebookUrl: import.meta.env.VITE_PUBLIC_FACEBOOK_URL || '',
    instagramUrl: import.meta.env.VITE_PUBLIC_INSTAGRAM_URL || '',
    whatsappNumber: import.meta.env.VITE_PUBLIC_WHATSAPP_NUMBER || '',
  },
  business: {
    phone: import.meta.env.VITE_PUBLIC_BUSINESS_PHONE || '+919964111963',
    email: import.meta.env.VITE_PUBLIC_BUSINESS_EMAIL || '',
    name: import.meta.env.VITE_PUBLIC_BUSINESS_NAME || 'Ashok Telecom & Communication',
    establishedYear: Number(import.meta.env.VITE_PUBLIC_ESTABLISHED_YEAR) || 2010,
  },
  forms: {
    contactUrl: import.meta.env.VITE_PUBLIC_CONTACT_FORM_URL || '/api/contact.php',
    bookServiceUrl: import.meta.env.VITE_PUBLIC_BOOK_SERVICE_FORM_URL || '/api/book-service.php',
    turnstileSiteKey: import.meta.env.VITE_PUBLIC_TURNSTILE_SITE_KEY || '',
  },
} as const;